// @flow
function normalizeGetterData(value: string) {
	try {
		return JSON.parse(value);
	} catch (error) {
		return value;
	}
}

function getData(storeName: string): any {
	if (!storeName) {
		console.error('storeName is required');
	}

	const data: string = localStorage.getItem(storeName) || '';
	if (!data) {
		console.warn(`no Data in ${storeName}`);
	}

	const normalizeData = normalizeGetterData(data);
	return normalizeData;
}

function normalizeSetterData(value) {
	if (typeof value === 'object') {
		return JSON.stringify(value);
	}
	return value;
}

function setData(storeName: string, value: any) {
	if (!storeName) {
		console.error('storeName is required');
	}
	const normalizeData = normalizeSetterData(value);
	localStorage.setItem(storeName, normalizeData);
}

function updateData(storeName: string, property: string, value: any) {
	if (!storeName) {
		console.error('storeName is required');
	}

	const prevData = getData(storeName);

	const updatedData = {
		...prevData,
		[property]: value,
	};
	setData(storeName, updatedData);
}

function removeData(storeName: string) {
	if (!storeName) {
		console.warn('storeName is required');
	}
	localStorage.removeItem(storeName);
}

export { getData, setData, removeData, updateData };
